import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormDialog from '../../../../library/form/components/FormDialog';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import { UiCol, UiGridColOne } from '../../../../library/layout/Index';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormInput from '../../../../library/form/components/FormInput';

const StockCheckListDeleteEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;

    // console.log("StockCheckRow", viewData);

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ actionParam:{actionType: 'markItemDeleted'},formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '120px' }}
            formStyle={{ width: '535px', height:"200px" }} formTitle={<SarasTrans value="Provide Reason for Delete" />}
        >
            <UiGridColOne>
                <UiCol>
                    <ul>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemName" }} value="Selected Item" />
                            </span>
                            <FormROValue formObject={formObject} rowKey="" action={{ paramName: "itemName" }}/>
                        </li>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "comment" }} value="Reason" />
                            </span>
                            <FormInput style={{width:"250px"}} formObject={formObject} rowKey="" 
                                action={{ InputType: "input", paramName: "comment", actionParam:{} }}
                                className='uiSpacerH10'/>
                        </li>
                    </ul>
                </UiCol>
            </UiGridColOne>
        </FormDialog>
    )
}

export default withView(StockCheckListDeleteEditor, "stockCheckListSystem", "stockCheckListSystem")